// @ts-nocheck

import DOMPurify from 'dompurify'
import { findAll } from 'highlight-words-core'
import React from 'react'

const HighlightedSearchResult = ({ label }, { inputValue }) => {
  const chunks = findAll({
    caseSensitive: false,
    searchWords: inputValue.split(/\s/),
    textToHighlight: label
  })
  const highlightedText = DOMPurify.sanitize(
    chunks
      .map((chunk) => {
        const { end, highlight, start } = chunk
        const text = label.substr(start, end - start)
        return highlight ? `<b>${text}</b>` : text
      })
      .join('')
  )
  return <span dangerouslySetInnerHTML={{ __html: highlightedText }} />
}

export default HighlightedSearchResult
